/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileError = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M3 2h10.414L19 7.586V10h-2V9h-5V4H5v16h3v2H3zm11 3.414V7h1.586z" />
        <path d="m10 22 5.5-11L21 22zm4.9-6.05v2.2h1.2v-2.2zm0 3.3v1.1h1.2v-1.1z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileError as FileError };
